import moment from 'moment';

export default {
  data() {
    return {
      interval: '',
      seconds: 0,
    };
  },
  created() {
    this.interval = setInterval(() => {
      if (!this.currentStatusStartTime) return;
      const unix = moment.unix(this.currentStatusStartTime);
      this.seconds = moment.utc().diff(unix, 'seconds');
    }, 200);
  },
  computed: {
    timer() {
      return this.convertSecondsInTimeWithFormat(this.seconds);
    },
    // TODO: declarar en local y retornar en esta computada var con una fecha de inicio local
    // currentStatusStartTime() {},
  },
  methods: {
    obtainFormat(seconds) {
      if (seconds >= 3600) return 'HH:mm:ss';
      return 'mm:ss';
    },
    convertSecondsInTimeWithFormat(time) {
      const format = this.obtainFormat(time);
      const duration = moment.duration(time, 'seconds');
      return moment.utc(duration.asMilliseconds()).format(format);
    },
  },
  beforeDestroy() {
    if (!this.interval) return;
    clearInterval(this.interval);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/timer.js